(function () {
  $(`body`).on(`click`, `[href*="#"]`, function (e) {
    const FIXED_OFFSET = 10;
    // eslint-disable-next-line no-invalid-this
    $(`html,body`).stop().animate({scrollTop: $(this.hash).offset().top - FIXED_OFFSET}, 300);
    e.preventDefault();
  });
})();
